const PIXEL_ID = '1433233358626559'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Loads the Meta Pixel base code once and fires the initial PageView.
 * Mirrors the official snippet, adapted for a React entry point.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || window.fbq) return

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq!.callMethod) {
      fbq!.callMethod.apply(fbq, args)
    } else {
      fbq!.queue!.push(args)
    }
  } as NonNullable<Window['fbq']>

  window.fbq = fbq
  if (!window._fbq) window._fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  const noscript = document.createElement('noscript')
  const pixelImage = document.createElement('img')
  pixelImage.height = 1
  pixelImage.width = 1
  pixelImage.style.display = 'none'
  pixelImage.alt = ''
  pixelImage.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(pixelImage)
  document.body.appendChild(noscript)

  fbq('init', PIXEL_ID)
  fbq('track', 'PageView')
}

/** Fires a standard Meta Pixel event, if the pixel has loaded. */
export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  window.fbq?.('track', event, params)
}
